// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 415 ? "c36f3faa" : chunkId) + "." + {"415":"46f60b2e115e2225","500":"428cfd24ef45fdaa"}[chunkId] + ".js";
};